import UltMeta, { Meta } from "./UltMeta/index";
// 客户定义

class Role extends UltMeta {
    CUSTOMER = new Meta(1, "采购商");
    SUPPLIER = new Meta(2, "供应商");
    SUPPLY_CHAIN = new Meta(3, "联合购销商");
    CARRIER = new Meta(4, "承运商");
}
export const ROLE = new Role();

// 子账号权限
class Permission extends UltMeta {
    INTENTION = new Meta(1, "意向专员");
    CONTRACT = new Meta(2, "合同专员");
    PAYMENT = new Meta(3, "付款专员");
    FREIGHT = new Meta(4, "提货专员");
    SIGNATURE = new Meta(5, "签收专员");
    RECONCILIATION = new Meta(6, "对账专员");
    INVOICE = new Meta(7, "开票专员");
    LOGISTICS = new Meta(8, "物流专员");
}
export const PERMISSION = new Permission();

class State extends UltMeta {
    ACTIVE = new Meta(1, "启用");
    INACTIVE = new Meta(0, "禁用");
}

export const STATE = new State();

class FindType extends UltMeta {
    SHIP_CARRIER = new Meta(1, "船舶关联查询");
    PURCHASE_DEMAND = new Meta(2, "购买意向");
}
export const FIND_TYPE = new FindType();

/**
 * 会员状态
 */
class MemberState extends UltMeta {
    ACTIVE = new Meta(1, "激活");
    EXPIRY = new Meta(2, "过期");
}
export const MEMBER_STATE = new MemberState();

/**
 * 是否有推广资格
 */
class HasPromotion extends UltMeta {
    YES = new Meta(1, "有");
    CLOSED = new Meta(2, "关闭");
    NO = new Meta(3, "没有");
}
export const HAS_PROMOTION = new HasPromotion();

/**
 * 用来区分获取openid配置文件的枚举(链云/链运)
 */
class Origin extends UltMeta {
    CUSTOMER = new Meta(1, "链云");
    CARRIER = new Meta(2, "船务");
}
export const ORIGIN = new Origin();

/**
 * 用来区分用户绑定和更新邮箱状态的枚举
 */
class EmailType extends UltMeta {
    BIND = new Meta(1, "绑定");
    UPDATE = new Meta(2, "更新");
}
export const EMAIL_TYPE = new EmailType();

/**
 * 用来区分获取openid配置文件的枚举(链云/链运)
 */
class RegisterSource extends UltMeta {
    LIAN_YUN = new Meta(1,"链云砂石");

    CHUAN_WU = new Meta(2,"链云船务");
}
export const REGISTER_SOURCE = new RegisterSource();